import { Global, Constructors } from '../models/Global';

export class PagedSlotList {
    
    
    pageNo;
    isLastPage;
    
    index;
    
    slots;
    
    //Construct from the backend Json Response.
    constructor(json) {
        if (json) {
            this.isLastPage = json.last; 
            this.pageNo = json.pageNo; 
            this.index = json.index;

            if (json.items)
                this.slots = json.items.map(item => Constructors.slotFromJson(item, Global.getTimezone()));
            else
                this.slots = [];
        }  
    } 
    
    isFirst = () => {
        return this.pageNo === 0;
    }
    
    isLast = () => {
        return this.isLastPage;
    }
    
}